import { t } from '@sm/intl';

import SUMMARY_COPY from './summary/copy';
import DETAILS_COPY from './details/copy';

import { DisplayFeatureStatic } from '~shared/types/pricing/features';
import { Copy } from '~shared/types/pricing/copy';

/**
 * A formatter method that takes a map of l10n ready strings and builds a DisplayFeatureStatic
 * object populating summary/tooltip values wrapped with l10n formatting
 *
 * @param COPY_MAP The l10n copy object that will be referenced in building DisplayFeature objects
 * @returns A curried function that will generate DisplayFeature objects with l10n formatting
 */
function createFeatureFormatter<T extends Copy>(COPY_MAP: T) {
  return (featureName: string, formatValues?: Record<string, string | number>): DisplayFeatureStatic => {
    const tooltipKey = `${String(featureName)}_tooltip`;
    const tooltipHeadingKey = `${String(featureName)}_tooltip_heading`;
    const tooltip = tooltipKey in COPY_MAP && COPY_MAP[tooltipKey as keyof typeof SUMMARY_COPY];
    const tooltipHeading = tooltipHeadingKey in COPY_MAP && COPY_MAP[tooltipHeadingKey as keyof typeof SUMMARY_COPY];

    return {
      name: featureName,
      summary: COPY_MAP[featureName] ? t(COPY_MAP[featureName], formatValues) : undefined,
      tooltip: tooltip ? t(tooltip, formatValues) : undefined,
      tooltipHeading: tooltipHeading ? t(tooltipHeading, formatValues) : undefined,
    };
  };
}

export const formatSummaryFeature = createFeatureFormatter<typeof SUMMARY_COPY>(SUMMARY_COPY);
export const formatDetailsFeature = createFeatureFormatter<typeof DETAILS_COPY>(DETAILS_COPY);
